<template>
  <!-- MODALE AFFICHAGE -->
  <b-modal
    body-class="eolienne-informations"
    v-if="eolienne"
    id="modal-eolienne-show"
    size="xl"
    :title="`Fiche de  l'éolienne ` + getNomEolienneElseId(eolienne)"
    title-class="eolienne-informations__title"
  >
    <b-row>
      <!-- Localisation -->
      <b-col sm="12" lg="6" class="mb-sm-3 mb-md-0 eolienne-map">
        <b-card title="Localisation">
          <hr />
          <!-- Map -->
          <card class="m-0 p-0 eolienne-map__card">
            <template #image>
              <div class="map eolienne-map__window">
                <l-map :zoom="mapZoom" :center="mapCenter">
                  <l-tile-layer
                    :url="baseLayer.url"
                    :attribution="baseLayer.attribution"
                  ></l-tile-layer>
                  <l-marker
                    v-for="(marker, index) in markers"
                    :key="index"
                    :lat-lng="marker"
                  ></l-marker>
                </l-map>
              </div>
            </template>
          </card>
          <!-- Infos -->
          <b-card-text class="mt-3">
            <p v-if="eolienne.inventaireCommune">
                <span v-if="eolienne.inventaireCommune.nomCommune">
                  {{ eolienne.inventaireCommune.nomCommune }}
                  ({{ eolienne.inventaireCommune.codeDepartement }})
                </span>
            </p>
            <div>
              <h5 class="mb-2 info-coordinate-title">Coordonnées <span>{{ parc.projection.libelle }}</span></h5>
              <ul class="list-unstyled">
                <li class="m-2" v-if="eolienne.xaerogenerateur"
                >X : {{ eolienne.xaerogenerateur }}
                </li>
                <li v-else class="m-2 empty-field">
                  {{ emptyfield }}
                </li>
                <li class="m-2" v-if="eolienne.yaerogenerateur "
                >Y : {{ eolienne.yaerogenerateur }}
                </li>
                <li v-else class="m-2 empty-field">
                  {{ emptyfield }}
                </li>
              </ul>
            </div>
          </b-card-text>
        </b-card>
      </b-col>

      <b-col sm="12" lg="6" class="mt-sm-3 mt-lg-0">
        <!-- Caractérisques -->
        <b-card title="Caractérisques">
          <hr />
          <b-card-text class="mt-3">
            <p>
                <span>
                  Puissance installée :
                  <span v-if="eolienne.puissance">
                    {{ eolienne.puissance }} MW
                  </span>
                  <span v-else class="empty-field"> {{ emptyfield }} </span>
                </span>
            </p>
            <p>
              Période d'allumage :
              <span v-if="eolienne.periodeAllumage">
                  {{ eolienne.periodeAllumage.libelle }}
                </span>
              <span v-else class="empty-field"> {{ emptyfield }} </span>
            </p>
            <p>
              Type de feux :
              <span v-if="eolienne.typeFeu && eolienne.typeFeu.libelle">
                  {{ eolienne.typeFeu.libelle }}
                </span>
              <span v-else class="empty-field"> {{ emptyfield }} </span>
            </p>

            <p>
              Constructeur :
              <span v-if="eolienne.constructeur">
                  {{ eolienne.constructeur.nom }}
                </span>
              <span v-else-if="eolienne.constructeurAutre">
                  {{ eolienne.constructeurAutre }}</span
              >
              <span v-else class="empty-field"> {{ emptyfield }} </span>
            </p>
            <p>
              Référence :
              <span v-if="eolienne.referenceModele">
                  {{ eolienne.referenceModele.referenceCommerciale }}
                </span>
              <span v-else-if="eolienne.referenceAutre">
                  {{ eolienne.referenceAutre }}</span
              >
              <span v-else class="empty-field">
                  {{ emptyfield }}
                </span>
            </p>
          </b-card-text>
        </b-card>

        <!-- Gabarit -->
        <b-card title="Gabarit" class="mb-md-0">
          <hr />
          <b-card-text class="mt-3">
            <p>
              Côte NGF au sol :
              <span v-if="eolienne.coteNgf">{{ eolienne.coteNgf }} m</span
              ><span v-else class="empty-field">
                  {{ emptyfield }}
                </span>
            </p>
            <p>
              Hauteur totale en bout de pale :
              <span v-if="eolienne.hauteurTotale"
              >{{ eolienne.hauteurTotale }} m</span
              >
              <span v-else class="empty-field">
                  {{ emptyfield }}
                </span>
            </p>
            <p>
              Hauteur du mât + nacelle :
              <span v-if="eolienne.hauteurMatNacelle"
              >{{ eolienne.hauteurMatNacelle }} m</span
              >
              <span v-else class="empty-field">
                  {{ emptyfield }}
                </span>
            </p>
            <p>
              Diamètre du rotor :
              <span v-if="eolienne.diametreRotor"
              >{{ eolienne.diametreRotor }} m</span
              >
              <span v-else class="empty-field">
                  {{ emptyfield }}
                </span>
            </p>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
    <template #footer="{cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->

      <b-button
        variant="default"
        title="Revenir sur le panneau d'administration."
        @click="cancel()"
      >
        Retour
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";
import {BModal, BButton, BCardText, BCol, BRow, BCard} from "bootstrap-vue-next";

import {useReactiveStoreGetters} from "@/composables/useStore";
import {ref} from "vue";

// Data
const emptyfield = ref("Non renseigné(e)");

defineProps({
  getNomEolienneElseId: {
    type: Function,
    required: true,
  },
  mapZoom: {
    type: Number,
    required: true,
  },
  mapCenter: {
    required: true,
  },
  eolienne: {
    type: [Object, null],
    required: true,
  },
  markers: {
    type: Array,
    required: true,
  },
})

const { parc, baseLayer } = useReactiveStoreGetters(["parc", "baseLayer"]);

</script>
<style lang="scss">
.eolienne-informations {
  background: #f4f3ef;
  &__title {
    font-size: 1.6rem;
    margin-bottom: 0;
  }

  .empty-field {
    font-style: italic;
    font-size: 0.9em;
  }
}
.eolienne-map {
  &__card {
    height: 250px;
  }
  &__window {
    height: 250px;
  }
  & > .card {
    height: 100%;
  }
}
.empty-field {
  font-style: italic;
}
</style>
